import { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import ActionButton from 'jbc-front/components/ActionButton';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { displayFormat } from '@/components/utils/formatter';
import { MoreHealthCheckupInstitutionsModal } from '../MoreHealthCheckupInstitutionsModal';
import type { Schema } from '../../schema';
import styles from './HealthCheckupInstitution.scss';

interface HealthCheckupInstitutionProps {
  reportId: string;
}

export const HealthCheckupInstitution: FC<HealthCheckupInstitutionProps> = ({ reportId }) => {
  const { watch } = useFormContext<Schema>();
  const [isOpenModal, setIsOpenModal] = useState(false);

  const hciName = watch('healthCheckupInstitutionName') ?? '';
  const hciLocation = watch('healthCheckupInstitutionLocation') ?? '';
  const hciCount = watch('healthCheckupInstitutionsCount');
  const hasManyInstitutions = (hciCount || 0) > 1;

  return (
    <Panel>
      <Headding>健康診断実施機関</Headding>
      <Item>
        <div>
          <div className={styles.label}>健康診断実施機関名称</div>
          <Spacer size={10} />
          <div className={styles.value}>{displayFormat(hciName)}</div>
        </div>

        <div className="u-mt20">
          <div className={styles.label}>健康診断実施機関所在地</div>
          <Spacer size={10} />
          <div className={styles.value}>{displayFormat(hciLocation)}</div>
        </div>

        {hasManyInstitutions && (
          <div className="u-mt20">
            <ActionButton onClick={() => setIsOpenModal(true)}>その他健康診断実施機関</ActionButton>
          </div>
        )}

        <MoreHealthCheckupInstitutionsModal
          reportId={reportId}
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
        />
      </Item>
    </Panel>
  );
};
